import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  // async auditLogoutUsuario(userId: string) {
  //   const request = await api.post(`/usuario/${userId}/audit-logout-usuario`, null)
  //   return factory.build(request)
  // },

  async getLogoutConfigurationByHospitalId(hospitalId: string) {
    const request = await api.get(`agendamento/hospital/${hospitalId}/configuracao-logout`)
    return factory.build(request)
  },
}
